import { configure } from 'mobx';

import { createPublicAPI } from './viewer';

configure({ isolateGlobalState: true });

export const exports = () => {
  return createPublicAPI();
};
